import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import type { DBDepartment } from "@/lib/db-types";

export const ALL_DEPARTMENTS = "all";

interface DepartmentToggleProps {
  departments: DBDepartment[];
  value: string;
  onChange: (value: string) => void;
}

/** Oslo / Bergen / Begge. Verdien er avdelings-id eller ALL_DEPARTMENTS. */
export function DepartmentToggle({ departments, value, onChange }: DepartmentToggleProps) {
  return (
    <ToggleGroup
      type="single"
      variant="outline"
      size="sm"
      value={value}
      onValueChange={(v) => v && onChange(v)}
      aria-label="Avdeling"
    >
      {departments.map((d) => (
        <ToggleGroupItem key={d.id} value={d.id} aria-label={d.name}>
          {d.name}
        </ToggleGroupItem>
      ))}
      <ToggleGroupItem value={ALL_DEPARTMENTS} aria-label="Begge avdelinger">
        Begge
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
